import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { getAdminReferrals } from '../../api/client';
import { useToast } from '../../contexts/ToastContext';
import Card from '../../components/ui/Card';
import { Users, Loader2 } from 'lucide-react';

export default function AdminReferrals(): React.JSX.Element {
  const toast = useToast();
  const [referrals, setReferrals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    loadReferrals();
  }, [page]);

  const loadReferrals = async () => {
    setLoading(true);
    try {
      const res = await getAdminReferrals({ page: String(page), per_page: '20' });
      setReferrals(res.data || []);
    } catch (err: any) {
      toast.show(err.message || 'Failed to load referrals', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <Users className="w-7 h-7 text-amber-600" />
          <h1 className="text-2xl font-bold text-slate-900">All Referrals</h1>
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
          </div>
        ) : referrals.length === 0 ? (
          <Card className="text-center py-12 text-slate-500">No referrals found.</Card>
        ) : (
          <div className="space-y-3">
            {referrals.map((r) => (
              <Card key={r.id} className="flex items-center justify-between gap-4">
                <div>
                  <p className="font-semibold text-slate-900">{r.referrer_name}</p>
                  <p className="text-xs text-slate-500">Referred: {r.referred_name}</p>
                  <p className="text-xs text-slate-400">Code: {r.code}</p>
                </div>
                <div className="text-right">
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-semibold ${
                    r.status === 'paid' ? 'bg-emerald-50 text-emerald-700' :
                    r.status === 'qualified' ? 'bg-amber-50 text-amber-700' :
                    'bg-slate-100 text-slate-600'
                  }`}>
                    {r.status}
                  </span>
                  <p className="text-xs text-slate-400 mt-1">{new Date(r.created_at).toLocaleDateString()}</p>
                </div>
              </Card>
            ))}
          </div>
        )}

        <div className="flex justify-center gap-2 mt-6">
          <button
            onClick={() => setPage(Math.max(1, page - 1))}
            disabled={page === 1}
            className="px-4 py-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200 disabled:opacity-50"
          >
            Previous
          </button>
          <span className="px-4 py-2 text-sm text-slate-600">Page {page}</span>
          <button
            onClick={() => setPage(page + 1)}
            className="px-4 py-2 rounded-lg bg-slate-100 text-slate-600 hover:bg-slate-200"
          >
            Next
          </button>
        </div>
      </div>
    </AdminLayout>
  );
}
